import React, { Suspense } from "react";
import { Box } from "./Box";
// import { Text } from "@react-three/drei";
import { extend } from "@react-three/fiber";
import { Text } from "@react-three/drei";
import { Config } from "../types";
import resourceInfo from "../resourceInfo.json";

// extend({ Text });

export default function MultipleResourceCube({
  config,
  setConfig,
}: {
  config: Config;
  setConfig: React.Dispatch<React.SetStateAction<Config>>;
}) {
  return (
    <>
      <Box position={[-15, 15, 20]} size={[30, 10, 20]} resourceId={1} config={config} setConfig={setConfig} />
      <Box position={[-15, 0, 20]} size={[30, 20, 20]} resourceId={2} config={config} setConfig={setConfig} />
      <Box position={[-15, -20, 20]} size={[30, 20, 20]} resourceId={3} config={config} setConfig={setConfig} />
      <Box position={[-15, 0, 0]} size={[30, 60, 20]} resourceId={4} config={config} setConfig={setConfig} />
      <Box position={[-15, 0, -20]} size={[30, 60, 20]} resourceId={5} config={config} setConfig={setConfig} />
      <Box position={[-15, 25, 20]} size={[30, 10, 20]} resourceId={6} config={config} setConfig={setConfig} />

      <Box position={[15, 15, 20]} size={[30, 10, 20]} resourceId={7} config={config} setConfig={setConfig} />
      <Box position={[15, 0, 20]} size={[30, 20, 20]} resourceId={8} config={config} setConfig={setConfig} />
      <Box position={[15, -20, 20]} size={[30, 20, 20]} resourceId={9} config={config} setConfig={setConfig} />
      <Box position={[15, 0, 0]} size={[30, 60, 20]} resourceId={10} config={config} setConfig={setConfig} />
      <Box position={[15, 0, -20]} size={[30, 60, 20]} resourceId={11} config={config} setConfig={setConfig} />
      <Box position={[15, 25, 20]} size={[30, 10, 20]} resourceId={12} config={config} setConfig={setConfig} />

      <Suspense fallback={null} key={"regiontext" + "aa"}>
        <Text
          position={[15, -30, 40]}
          scale={[10, 10, 10]}
          color={
            // @ts-ignore
            !config.selectedResource || resourceInfo[config.selectedResource].name.includes("Verbal")
              ? "black"
              : "white"
          }
          fontSize={0.5}
        >
          Verbal
        </Text>
        <Text
          position={[-15, -30, 40]}
          scale={[10, 10, 10]}
          color={
            // @ts-ignore
            !config.selectedResource || resourceInfo[config.selectedResource].name.includes("Spatial")
              ? "black"
              : "white"
          }
          fontSize={0.5}
        >
          Spatial
        </Text>
        <Text
          position={[-45, -20, 20]}
          scale={[10, 10, 10]}
          color={
            // @ts-ignore
            !config.selectedResource || resourceInfo[config.selectedResource].name.includes("Tactile")
              ? "black"
              : "white"
          }
          fontSize={0.3}
          rotation={[0, -Math.PI / 2, 0]}
        >
          Tactile
        </Text>
        <Text
          position={[-45, -0, 20]}
          scale={[10, 10, 10]}
          color={
            // @ts-ignore
            !config.selectedResource || resourceInfo[config.selectedResource].name.includes("Auditory")
              ? "black"
              : "white"
          }
          fontSize={0.3}
          rotation={[0, -Math.PI / 2, 0]}
        >
          Auditory
        </Text>
        <Text
          position={[-45, 20, 20]}
          scale={[10, 10, 10]}
          color={
            // @ts-ignore
            !config.selectedResource || resourceInfo[config.selectedResource].name.includes("Visual")
              ? "black"
              : "white"
          }
          fontSize={0.3}
          rotation={[0, -Math.PI / 2, 0]}
        >
          Visual
        </Text>
        <Text
          position={[-35, 25, 20]}
          scale={[10, 10, 10]}
          color={
            // @ts-ignore
            !config.selectedResource || resourceInfo[config.selectedResource].name.includes("Ambient")
              ? "black"
              : "white"
          }
          fontSize={0.3}
          rotation={[0, -Math.PI / 2, 0]}
        >
          Ambient
        </Text>
        <Text
          position={[-35, 15, 20]}
          scale={[10, 10, 10]}
          color={
            // @ts-ignore
            !config.selectedResource || resourceInfo[config.selectedResource].name.includes("Focal") ? "black" : "white"
          }
          fontSize={0.3}
          rotation={[0, -Math.PI / 2, 0]}
        >
          Focal
        </Text>
        <Text
          position={[-55, -0, 20]}
          scale={[10, 10, 10]}
          color={
            // @ts-ignore
            !config.selectedResource || resourceInfo[config.selectedResource].name.includes("Perception")
              ? "black"
              : "white"
          }
          fontSize={0.3}
          rotation={[0, -Math.PI / 2, 0]}
        >
          Perception
        </Text>
        <Text
          position={[-55, -0, 0]}
          scale={[10, 10, 10]}
          color={
            // @ts-ignore
            !config.selectedResource || resourceInfo[config.selectedResource].name.includes("Cognition")
              ? "black"
              : "white"
          }
          fontSize={0.3}
          rotation={[0, -Math.PI / 2, 0]}
        >
          Cognition
        </Text>
        <Text
          position={[-55, -0, -20]}
          scale={[10, 10, 10]}
          color={
            // @ts-ignore
            !config.selectedResource || resourceInfo[config.selectedResource].name.includes("Response")
              ? "black"
              : "white"
          }
          fontSize={0.3}
          rotation={[0, -Math.PI / 2, 0]}
        >
          Response
        </Text>
      </Suspense>
    </>
  );
}
